import React from "react";
import { SampleQuestion } from "./SampleQuestion";
import { AnswerBubble } from "./AnswerBubble";
import { InputArea } from "./InputArea";
import { Footer } from "./Footer";
import { alpha } from "../constants";

export function ChatBotPreview({ colors, company, inputPos }) {
  const { bg, chatbox, textPrimary, border, inputBg, brand, headerBg, headerText, footerBg, footerText, buttonBg,searchbarBg,tilesBg } = colors;
  const header = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 14px",
        borderBottom: `1px solid ${border}`,
        background: headerBg,
        flexShrink: 0,
        cursor: "move",
        minWidth: 0,
      }}
    >
      <span
        style={{
          fontSize: 14,
          fontWeight: 700,
          color: headerText,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {company}
      </span>
      <div style={{ display: "flex", gap: 6, alignItems: "center", flexShrink: 0 }}>
        <span
          style={{
            fontSize: 10,
            padding: "3px 8px",
            borderRadius: 6,
            background: buttonBg || "#111111",
            color: "#fff",
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          📅 Book
        </span>
        <span
          style={{
            width: 26,
            height: 26,
            borderRadius: 6,
            background: alpha(buttonBg || "#111111", 0.12),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 13,
            color: brand,
          }}
        >
          ×
        </span>
      </div>
    </div>
  );

  const body = (
    <div
      style={{
        flex: 1,
        overflowY: "auto",
        padding: "10px 12px",
        background: bg,
        display: "flex",
        flexDirection: "column",
        gap: 8,
        minWidth: 0,
      }}
    >
      <SampleQuestion text="What services do you offer?" color={textPrimary} />
      <AnswerBubble
        bg={chatbox}
        textColor={textPrimary}
        borderColor={border}
        brand={brand}
        inputBg={inputBg}
        buttonBg={buttonBg}
        tilesBg={tilesBg}
      />
    </div>
  );

  const input = (
    <InputArea
      bg={bg}
      inputBg={inputBg}
      borderColor={border}
      textColor={textPrimary}
      brand={brand}
      buttonBg={buttonBg}
      searchbarBg={searchbarBg}
    />
  );

  const footer = (
    <Footer bg={footerBg} borderColor={border} textColor={footerText} brand={brand} />
  );

  return (
    <>
      {header}
      {inputPos === "top" ? (
        <>{input}{body}</>
      ) : (
        <>{body}{input}</>
      )}
      {footer}
    </>
  );
}